import { FormItem } from "@/cs-ts-bridge/ts/form-item";
import { BaseElementDef, BaseElementDefBase } from "./BaseElementDef";
import { FormDefinitionItem } from "./__DefinitionDataInterface";
import { LexmarkIntegrationSettings } from "@cs-ts/lexmark-integration-settings";
import { CalculationContext } from "./__CalculationContextInterface";

export default class LexmarkIntegrationDef extends BaseElementDef<LexmarkIntegrationSettings, FormDefinitionItem<LexmarkIntegrationSettings>, FormItem> {
    constructor(parentElement: BaseElementDefBase | null, elementData: FormItem, definitionData: FormDefinitionItem<LexmarkIntegrationSettings>, calculationContext: CalculationContext) {
        super(parentElement, elementData, definitionData, calculationContext);
        this.typeName = "MI.Common.DynamicForms.Models.LexmarkIntegrationDef"; // TODO - not hardcoded?
    }

    hasCustomConfirmComponent(adminPreview: boolean) {
        return adminPreview;
    }

    async getCustomConfirmComponent(adminPreview: boolean) {
        const func = (await import(/* webpackChunkName: "PageAdmin" */ "./LexmarkIntegrationDef.Admin")).getCustomConfirmComponent;
        return await func.apply(this, []);
    }
}
